export class Solicitud{

    public nombre : any;
    public identificacion: any;
    public email: any;
    public edad : any;
    public numCelular: any;
    public numFijo: any;
    public ciudad: any;
    public pregunta1: any;
    public pregunta2: any;
    public pregunta3: any;
    public ipOrigen: any;
    
}